import request from "@/utils/request";

export function getStores(params) {
  return request({
    url: "/api/admin/stores/",
    method: "get",
    params,
  });
}
export function getStoreById(storeId) {
  return request({
    url: `/api/admin/stores/${storeId}/`,
    method: "get",
  });
}
/**
 * @example {
  "id": 0,
  "city": "Наро-Фоминск",
  "address": "ул. Ленина дом 3",
  "comments": "Вход с ул. Ленина",
  "worktime": [
    {
      "day": "MONDAY",
      "open": "8:00",
      "close": "22:00"
    }
  ],
  "region": 0
}
 */
export function createStore(data) {
  data.region = data.region.id;

  return request({
    url: `/api/admin/stores/`,
    method: "post",
    data,
  });
}
export function deleteStore(storeId) {
  return request({
    url: `/api/admin/stores/${storeId}/`,
    method: "delete",
  });
}
export function updateStore(storeId, data) {
  if ("region" in data) {
    data.region = data.region.id;
  }
  return request({
    url: `/api/admin/stores/${storeId}/`,
    method: "patch",
    data,
  });
}
